<template>
    <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
        <slot></slot>
    </div>
</template>